import React from "react";
import PortfolioAssetField from "forms/fields/PortfolioAssetField";
import PropTypes from "prop-types";

const PortfolioAsset = ({ assets, formik: { setFieldValue }, portfolio, portfolios }) => (
  <PortfolioAssetField
    assets={assets}
    onSelectPortfolio={() => setFieldValue("assets", null)}
    portfolio={portfolio}
    portfolios={portfolios}
  />
);

PortfolioAsset.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  portfolio: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default PortfolioAsset;
